export default __webpack_public_path__ + "static/media/category.06b408f0.svg";